import { combineReducers } from '@reduxjs/toolkit';
import userReducer from './user/slice';
import panZoomReducer from './zoom/panZoomSlice';
import systemReducer from './system/systemSlice';
import assetsPanelReducer from './assetsPanel/assetsPanelSlice';
import featureFlagsReducer from './featureFlags/slice';
import pagesReducer from './pages/slice';
import notificationsReducer from './notifications/slice';
import sectionReducer from './section/slice';
import globalStyleReducer from './globalStyles/slice';
import domainsReducer from './domains/slice';
import analyticsReducer from './analytics/analyticsSlice';
import wizardReducer from './wizard/slice';
import brandProfilesReducer from './brandProfiles/slice';

const rootReducer = combineReducers({
  user: userReducer,
  panZoom: panZoomReducer,
  system: systemReducer,
  assetsPanel: assetsPanelReducer,
  featureFlags: featureFlagsReducer,
  pages: pagesReducer,
  notifications: notificationsReducer,
  sections: sectionReducer,
  globalStyles: globalStyleReducer,
  domains: domainsReducer,
  analytics: analyticsReducer,
  wizard: wizardReducer,
  brandProfiles: brandProfilesReducer,
});

export default rootReducer;
